import { createStash } from "@latticexyz/stash/internal";
import config from "../../mud.config";

export const stash = createStash(config);
